import { Box, Divider, IconButton, Paper, Typography } from '@mui/material';
import AutocompleteFreeSolo from '../Inputs/AutocompleteFreeSolo';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildRedirectTranslatedUrl } from '../../lib/helperFuncs';


function Search({ regionsParametrics = [], lvl1Options = [] }:
  { regionsParametrics: any, lvl1Options: any }) {
  const [selectedRegion, setSelectedRegion] = React.useState<any>('');
  const [selectedLvl1, setSelectedLvl1] = React.useState<any>('');
  const { t } = useTranslation();
  const onSearch = () => {


    let url = `${buildRedirectTranslatedUrl()}/location`;

    if (!selectedRegion && !selectedLvl1) {
      window.location.href = url;

    }

    url += selectedLvl1
      ? `?level1=${selectedLvl1.value}`
      : '';
    url += selectedRegion
      ? selectedLvl1
        ? `&regions=${regionsParametrics.find((x: any) => x.value == selectedRegion.value)?.key}`
        : `?regions=${regionsParametrics.find((x: any) => x.value == selectedRegion.value)?.key}`
      : '';

    window.location.href = url;
  };

  return (<Box display='flex' justifyContent='flex-start'
    my={4}>
    <Paper
      elevation={0}
      component='form'
      sx={{ borderRadius: '50px', boxShadow: '1', p: '5px 3px 5px 0px', display: 'flex', alignItems: 'center', width: 700, height: 45 }}
    >
      <Typography fontWeight={600} m={2}
      >
        {t('Που')}
      </Typography>
      <AutocompleteFreeSolo
        onChange={(_: any, newValue: any) => setSelectedRegion(newValue)}
        optionsList={regionsParametrics.map((x: any) => {
          return { label: t(x.key), value: t(x.value) };
        })}
        placeholder={t('Τοποθεσία')} />

      <Divider sx={{ height: 28, m: 0.5, marginRight: 3 }} orientation='vertical' />
      <Typography fontWeight={600}
      >
        {t('Βρες')}
      </Typography>
      <AutocompleteFreeSolo
        onChange={(_: any, newValue: any) => setSelectedLvl1(newValue)}
        optionsList={lvl1Options.map((x: any) => { return { label: t(x.key), value: x.value }; })}
        placeholder={t('πχ: Νησί')} />

      <IconButton onClick={onSearch} size='large'
        type='button'
        sx={{ backgroundColor: '#5ba3e5', p: '10px' }} aria-label='search' >
        <SearchIcon />
      </IconButton>

    </Paper>
  </Box>
  );
}

export default Search;